// Just setup to get some dummy data in the filter list
// some should maybe be enums or something in final usage?

export type RangeFilterQueryKeys = {
  priceStartRangeKey: string;
  priceEndRangeKey: string;
  modelYearStartRangeKey: string;
  modelYearEndRangeKey: string;
  mileageStartRangeKey: string;
  mileageEndRangeKey: string;
};

export type CheckboxQueryKeys = {
  brandsKey: string;
  modelsKey: string;
  fuelKey: string;
  driveWheelKey: string;
  equipmentKey: string;
  salesTypesKey: string;
  colorKey: string;
  availabilityKey: string;
};

export type StringQueryKeys = {
  departmentsKey: string;
};

export type FilterQueryKeys = RangeFilterQueryKeys &
  CheckboxQueryKeys &
  StringQueryKeys;

export const filterQueryKeys: FilterQueryKeys = {
  brandsKey: "brands",
  modelsKey: "models",
  fuelKey: "Fuels",
  driveWheelKey: "DriveWheels",
  priceStartRangeKey: "PriceStart",
  priceEndRangeKey: "PriceEnd",
  modelYearStartRangeKey: "ModelYearStart",
  modelYearEndRangeKey: "ModelYearEnd",
  mileageStartRangeKey: "MileageStart",
  mileageEndRangeKey: "MileageEnd",
  departmentsKey: "departments",
  equipmentKey: "equipment",
  colorKey: "colors",
  salesTypesKey: "isLeasing", //Add own type if more sales types are added
  availabilityKey: "Availability",
};
